import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _91a32b4a = () => interopDefault(import('../pages/catalog/index.vue' /* webpackChunkName: "pages/catalog/index" */))
const _fa7ca88e = () => interopDefault(import('../pages/search.vue' /* webpackChunkName: "pages/search" */))
const _747a7908 = () => interopDefault(import('../pages/search/index.vue' /* webpackChunkName: "pages/search/index" */))
const _30b6b162 = () => interopDefault(import('../pages/search/documents.vue' /* webpackChunkName: "pages/search/documents" */))
const _5ed3c0ac = () => interopDefault(import('../pages/search/products.vue' /* webpackChunkName: "pages/search/products" */))
const _514227d1 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _95106dda = () => interopDefault(import('../pages/catalog/_slug.vue' /* webpackChunkName: "pages/catalog/_slug" */))
const _2c2e1c35 = () => interopDefault(import('../pages/documents/_slug/index.vue' /* webpackChunkName: "pages/documents/_slug/index" */))
const _c6ec3042 = () => interopDefault(import('../pages/news/_slug.vue' /* webpackChunkName: "pages/news/_slug" */))
const _42fca269 = () => interopDefault(import('../pages/product/_slug.vue' /* webpackChunkName: "pages/product/_slug" */))
const _4f8b8689 = () => interopDefault(import('../pages/_slug.vue' /* webpackChunkName: "pages/_slug" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/catalog",
    component: _91a32b4a,
    name: "catalog___ru"
  }, {
    path: "/search",
    component: _fa7ca88e,
    children: [{
      path: "",
      component: _747a7908,
      name: "search___ru"
    }, {
      path: "documents",
      component: _30b6b162,
      name: "search-documents___ru"
    }, {
      path: "products",
      component: _5ed3c0ac,
      name: "search-products___ru"
    }]
  }, {
    path: "/",
    component: _514227d1,
    name: "index___ru"
  }, {
    path: "/catalog/:slug",
    component: _95106dda,
    name: "catalog-slug___ru"
  }, {
    path: "/documents/:slug",
    component: _2c2e1c35,
    name: "documents-slug___ru"
  }, {
    path: "/news/:slug?",
    component: _c6ec3042,
    name: "news-slug___ru"
  }, {
    path: "/product/:slug?",
    component: _42fca269,
    name: "product-slug___ru"
  }, {
    path: "/:slug",
    component: _4f8b8689,
    name: "slug___ru"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
